import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

var thick = defineStyle({
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "divider.2",
});
var dividerTheme = defineStyleConfig({
    variants: { thick: thick },
    defaultProps: {
        variant: "thick",
    }
});

export { dividerTheme };
//# sourceMappingURL=divider.js.map
